module.exports = __webpack_public_path__ + "img/Diagnosis - Light Gray - Selected.786f1c0d.png";